import React, { useEffect, useState } from 'react';

import '../../styles/navbar.css'
import '../../styles/navbar-mobile.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCaretDown, faHome, faNewspaper, faSearch, faCog, faSignOutAlt, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch, connect } from 'react-redux';
import { hideDropDownMenu } from '../../redux/actions/dropdownMenuActions';
import fmplogo from '../../assets/FMP-Icon.png'
import { LogOutAuthAction } from '../../redux/actions/AuthAction';
import { useHistory, withRouter  } from 'react-router-dom';
import { setRowsDataSelectedIndexState, fetchInvoices } from '../../redux/actions/PostActions';
import { MediaQuery } from 'react-responsive'

function NavbarFMP(props) {
    
    const dispatch = useDispatch();
    let history = useHistory();
    const { login_check, chosenDropdownMenuState, dropdownMenu } = props;

    const [isVisible, setIsVisible] = useState(true)

    return (        

        <React.Fragment>
            <MediaQuery minDeviceWidth={768}>
                <div className="mainNavbarClass">

                    {/* <div className="navbarProfile">
                        <div className="navbar-nav navbarProfile-logout">
                            <a href="/">
                                <img src={fmplogo} width="115px" alt="Factory Motor Parts" border="0"/>
                            </a>                     
                        </div>                                        
                    </div> */}
                    <button className="mainNavbarButton" height="40px" onClick={()=>{
                        setIsVisible(!isVisible);
                    }}>

                    </button>
                    {isVisible ? ( 
                        <React.Fragment>
                            <ShowSideBarMenu />
                            
                            <div className="navbarProfile">
                                <div className="navbar-nav navbarProfile-logout">
                                    <button className="nav-link" onClick={ () => {
                                            dispatch(LogOutAuthAction(history));}}>
                                        <div className="menuBtnImage">
                                            <FontAwesomeIcon icon={faSignOutAlt} />
                                        </div>
                                        <div className="menuBtnDesc">
                                            Logout
                                        </div>                 
                                    </button>                    
                                </div>                                        
                            </div>
                        </React.Fragment>

                    ) : ''
                    }
                </div>
            </MediaQuery>        

            {/* tablet or mobile phone */}
            <MediaQuery maxDeviceWidth={767}>
                {/* <footer className="mainNavbarClass-mobile"> */}

                    {/* <div className="navbarProfile">
                        <div className="navbar-nav navbarProfile-logout">
                            <a href="/">
                                <img src={fmplogo} width="115px" alt="Factory Motor Parts" border="0"/>
                            </a>                     
                        </div>                                        
                    </div> */}

                    <ShowSideBarMenuMobile />
                    
                    {/* <div className="navbarProfile">
                        <div className="navbar-nav navbarProfile-logout">
                            <button className="nav-link" onClick={ () => {
                                    dispatch(LogOutAuthAction(history));}}>
                                <div className="menuBtnImage">
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                </div>
                                <div className="menuBtnDesc">
                                    Logout
                                </div>                 
                            </button>                    
                        </div>                                        
                    </div> */}
                {/* </footer> */}
            </MediaQuery>                 
        </React.Fragment>

    );
}
    
function ShowSideBarMenu() {

    const history = useHistory();
    const dispatch = useDispatch();
    const [ show, setShow ] = useState(false);

    const chosenDropdownMenuState = useSelector(state => state.chosenDropdownMenuReducer);
    const authreducerState = useSelector(state => state.authreducer);
    
    useEffect( () => { 
        setShow(true);        
        if(chosenDropdownMenuState !== undefined && chosenDropdownMenuState['hiddenDropdownList']['BATTERY_PROGRAM'] === 'HIDE'){
            setShow(false);
        }
    }, [chosenDropdownMenuState]);
    
    return (

        <nav className="navbar">           

            <ul className="navbar-nav-logo">
             
                <li className="topBarLogo fmp-logo">                        
                    <a href="/">
                        <img src={fmplogo} width="115px" alt="Factory Motor Parts" border="0"/>
                    </a>                                            
                </li>  
             </ul>

            <ul className="navbar-nav">             

                <li className="nav-item">
                    <button 
                        className="nav-link"
                        onClick={ () => {  
                            //history.push('/');
                            window.location.href='/'
                            //dispatch(fetchTransfers(authreducerState.user) )

                        } }>                         
                    
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faHome} />
                        </div>
                        <div className="menuBtnDesc">
                            Home
                        </div>

                    </button>
                    
                </li>

                        
                {
                    authreducerState.user.username === 'jxiong' || authreducerState.user.username === 'cthesing' || authreducerState.user.username === 'bfritz'? (
                        <li className="nav-item">
                            <button 
                                className="nav-link"
                                onClick={ () => {  
                                    window.location.href='/manageUsersConsignments'        
                                } }>                         
                            
                                <div className="menuBtnImage">
                                    <FontAwesomeIcon icon={faHome} />
                                </div>
                                <div className="menuBtnDesc">
                                    Manage<br/>Users<br/>Consignments
                                </div>
        
                            </button>                        
                        </li>
                    ) : ''
                }

                {/* <li className="nav-item">
                    <button 
                        className="nav-link"
                        onClick={ () => {  
                            history.push("/consignments");  
                            if(window.location.href.split("/").pop() === 'consignments'){                                
                                // dispatch(fetchInvoices(authreducerState.user) )
                                // dispatch(setRowsDataSelectedIndexState([]));
                            }                            
                        } }>                         
                    
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faFileInvoice} />
                        </div>
                        <div className="menuBtnDesc">
                            Consignments
                        </div>
                        
                    </button>
                </li> */}
                
            </ul>
        </nav>
    );
}

function ShowSideBarMenuMobile() {
    const authreducerState = useSelector(state => state.authreducer);
    
    const history = useHistory();
    const dispatch = useDispatch();

    return (

        <nav className="navbar-mobile">           
            <ul className="navbar-nav-mobile">             

                <li className="nav-item">
                    <button className="nav-link" onClick={ () => {
                            dispatch(LogOutAuthAction(history));}}>
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faSignOutAlt} />
                        </div>
                        <div className="menuBtnDesc">
                            Logout
                        </div>                 
                    </button>   
                    
                </li>

                <li className="nav-item">
                    <button 
                        className="nav-link"
                        onClick={ () => {  
                            window.location.href='/'
                        } }>                         
                    
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faHome} />
                        </div>
                        <div className="menuBtnDesc">
                            Home
                        </div>

                    </button>
                    
                </li>
                        
                {
                    authreducerState.user.username === 'jxiong' || authreducerState.user.username === 'cthesing' || authreducerState.user.username === 'bfritz'? (
                        <li className="nav-item">
                            <button 
                                className="nav-link"
                                onClick={ () => {  
                                    window.location.href='/manageUsersConsignments'        
                                } }>                         
                            
                                <div className="menuBtnImage">
                                    <FontAwesomeIcon icon={faHome} />
                                </div>
                                <div className="menuBtnDesc">
                                    Manage<br/>Users<br/>Consignments
                                </div>
        
                            </button>                        
                        </li>
                    ) : ''
                }                
            </ul>
        </nav>
    );
}
const routeChange_batteryCorporate = (history) =>{ 
    let path = `/battery/corporate`; 
    history.push(path);
  }

const BatteryProgramSubMenu = () => {
    const history = useHistory();
    return (
        <ul className="navbar-nav navbar-subNav batteryProgramCN">
            <li className="nav-item">
                <button 
                className="nav-link" 
                onClick={ () => {
                    routeChange_batteryCorporate(history)
                }} >  
                    <div className="menuBtnImage">
                        <FontAwesomeIcon icon={faNewspaper} />
                    </div>
                    <div className="menuBtnDesc">
                        Corporate
                    </div> 
                </button>                               
            </li>
        </ul>
    )
}



const mapStateToProps = (state) => {   
    return {
        chosenDropdownMenuState: state.chosenDropdownMenuReducer,
        // posts: state.posts,
        authreducer: state.authreducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        // fetch_transfers: (user) => {
        //     dispatch(fetchTransfers(user));
        // },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavbarFMP);